import PropTypes from 'prop-types';
import { Button } from '@etg/wings';
import { variants } from '@eti/components';
import { css, etiColors } from '@eti/styles';
import { useProperty, useTranslation } from '@eti/providers';
import { CaretRight } from '@phosphor-icons/react';
import isFunction from 'lodash/isFunction';
import { useScrollTo } from '@eti/utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const wrapperStyles = css`
  background-color: ${etiColors.white};
  bottom: 0;
  box-shadow: 0 0 5px ${etiColors.grayScale[8]};
  padding: 10px;
  position: relative;
  width: 100%;
  z-index: 10;

  @media (min-width: 48em) {
    padding: 15px;
  }
`;
const innerWrapperStyles = singleAction => css`
  display: flex;
  flex-shrink: 0;
  justify-content: ${singleAction ? 'flex-end' : 'space-between'};
  margin: 0 auto;
  max-width: 53rem;
  width: 100%;
`;

// TODO: Handle buttons with long texts AN-1941
const cancelButtonStyles = css`
  margin-right: 8px;
  min-width: 7.125rem;

  html[dir='rtl'] & {
    margin-left: 8px;
    margin-right: 0;
  }
`;
const continueButtonStyles = css`
  flex: 1;

  @media (min-width: 60.625em) {
    flex: initial;
  }
`;
const continueIconStyles = css`
  [dir='rtl'] & {
    transform: rotate(180deg);
  }
`;
const SeatMapFooter = _ref => {
  let {
    areAllSeatsSelected,
    selectNoOption,
    isPostBooking,
    onClose,
    onOptOut,
    onSaveAndContinue,
    setShowAllSeatsSelectedConfirmation,
    shouldShowSummary,
    totalPrice
  } = _ref;
  const {
    p
  } = useProperty();
  const {
    t
  } = useTranslation();
  const {
    scrollVertical
  } = useScrollTo();
  const optOutLabel = t('Product.SeatMap.Decline');
  const saveAndContinueLabel = t('Product.SeatMap.Button.Continue');
  const isDynamicBookingFlowEnabled = p('TravelerDetails.DynamicFlow.Enabled');
  const scrollToTop = () => scrollVertical('smooth', 0);
  const handleClose = e => {
    if (!shouldShowSummary) {
      if (isDynamicBookingFlowEnabled) {
        scrollToTop();
      }
      onSaveAndContinue(e);
      return;
    }
    if (!areAllSeatsSelected && isFunction(setShowAllSeatsSelectedConfirmation)) {
      setShowAllSeatsSelectedConfirmation(true);
      return;
    }
    if (totalPrice === 0 && isPostBooking) {
      selectNoOption();
      return;
    }
    onClose(e);
  };
  return /*#__PURE__*/_jsx("div", {
    className: wrapperStyles,
    "data-testid": "seatMapFooter",
    children: /*#__PURE__*/_jsxs("div", {
      className: innerWrapperStyles(!isFunction(onOptOut)),
      children: [isFunction(onOptOut) && /*#__PURE__*/_jsx(Button, {
        className: cancelButtonStyles,
        "data-testid": "cancelSeatMap-button",
        onClick: onOptOut,
        children: optOutLabel
      }), /*#__PURE__*/_jsx(Button, {
        className: continueButtonStyles,
        "data-testid": "saveAndContinue-button",
        iconSuffix: /*#__PURE__*/_jsx(CaretRight, {
          className: continueIconStyles
        }),
        onClick: handleClose,
        variant: variants.PRIMARY,
        children: saveAndContinueLabel
      })]
    })
  });
};
SeatMapFooter.propTypes = {
  areAllSeatsSelected: PropTypes.bool,
  isPostBooking: PropTypes.bool,
  onClose: PropTypes.func,
  onOptOut: PropTypes.func,
  onSaveAndContinue: PropTypes.func,
  selectNoOption: PropTypes.func,
  setShowAllSeatsSelectedConfirmation: PropTypes.func,
  shouldShowSummary: PropTypes.bool,
  totalPrice: PropTypes.number
};
export default SeatMapFooter;
//# sourceMappingURL=SeatMapFooter.js.map